import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Tracks the `prefers-reduced-motion: reduce` media query.
 *
 * `packages/tokens/src/tokens.css` sets `--duration-chart: 0ms` under this
 * media query, but that token is a CSS custom property and recharts takes
 * its animation duration from a JS prop (`animationDuration`) that never
 * reads it — so the token had no effect on any chart. This hook is the
 * bridge: pass its return value to a chart's `isAnimationActive` (and, for
 * charts that stay animated by design, gate `animationDuration` on it too)
 * so the reduced-motion preference is actually honoured.
 *
 * `useSyncExternalStore` with an SSR snapshot of `false` keeps this safe to
 * call during server rendering — same pattern already used in `CountUp`.
 */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(QUERY);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => window.matchMedia(QUERY).matches,
    () => false,
  );
}
